const BFF_ERROR_KEYS = {
  BFF_MISSING_SESSION: 'errors.bff.missingSession',
  BFF_BLOCKED_ORIGIN: 'errors.bff.blockedOrigin',
  BFF_UNSUPPORTED_ROUTE: 'errors.bff.unsupportedRoute',
  BFF_BACKEND_UNAVAILABLE: 'errors.bff.backendUnavailable',
  UNAUTHORIZED: 'errors.unauthorized',
  FORBIDDEN: 'errors.forbidden'
} as const

function resolveErrorCodeMessage(code: string, translate: (key: string) => string) {
  const key = `errors.codes.${code}`
  const translated = translate(key)

  return translated === key ? null : translated
}

function isTechnicalErrorMessage(message: string, code?: string) {
  return message === code || /^[A-Z][A-Z0-9]*(?:_[A-Z0-9]+)+$/.test(message)
}

export function resolveAppErrorMessage(error: unknown, translate: (key: string) => string) {
  if (error && typeof error === 'object' && 'code' in error && typeof error.code === 'string') {
    const key = BFF_ERROR_KEYS[error.code as keyof typeof BFF_ERROR_KEYS]
    if (key) return translate(key)

    const codeMessage = resolveErrorCodeMessage(error.code, translate)
    if (codeMessage) return codeMessage
  }

  if (error && typeof error === 'object' && 'message' in error && typeof error.message === 'string' && error.message) {
    const code = 'code' in error && typeof error.code === 'string' ? error.code : undefined
    return isTechnicalErrorMessage(error.message, code)
      ? translate('errors.generic')
      : error.message
  }

  return error instanceof Error ? error.message : translate('errors.generic')
}
